// src/common/components/leadForm/useLeadForm.ts
import { useState } from "react";
import { useSelector } from "react-redux";
import { getApi } from "../../../api/api";
import useMetrics from "../../hooks/useMetrics";
import { GoalType } from "../../types/enums";
import { selectIsOnline } from "../../../store/slices/networkSlice";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";

const phoneRegex = /^\+?[1-9]\d{1,14}$/;

export const useLeadForm = () => {
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const { trackGoal } = useMetrics();
  const isOnline = useSelector(selectIsOnline);
  const cluster = useSelector(selectCurrentCluster);
  const phoneNumber = cluster?.phone_number || "";

  const validatePhone = (value: string): boolean => {
    const isValid = phoneRegex.test(value);
    setPhoneError(!isValid);
    return isValid;
  };

  const handlePhoneChange = (value: string) => {
    setPhone(value);
    if (value.length === 0) {
      setPhoneError(false);
    } else if (phoneError) {
      validatePhone(value);
    }
  };

  const submit = async (phoneValue: string) => {
    if (!validatePhone(phoneValue)) return false;

    setLoading(true);
    setSuccess(false);
    setError(false);

    try {
      const api = getApi();
      await api.sendLead({ phone: phoneValue });

      setSuccess(true);
      setPhone("");
      setConsent(false);
      setPhoneError(false);
      trackGoal(GoalType.CALL_REQUEST, phoneValue);
      return true;
    } catch {
      setError(true);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    phone,
    setPhone: handlePhoneChange,
    consent,
    setConsent,
    loading,
    success,
    error,
    phoneError,
    submit,
    isOnline,
    phoneNumber,
  };
};